import { cn } from '@utils/helpers';
import { useFragment } from 'react-relay';
import { widgetFragment } from './Widget.relay';
import { WidgetTypeMap, isSideBySide } from './helpers';
import type { WidgetProps } from './types';

export const Widget: React.FC<WidgetProps> = ({ component, location }) => {
  const data = useFragment(widgetFragment, component);

  return (
    <div className={cn('w-full mb-16', isSideBySide(data.name) && 'desktop:w-[45%]')}>
      <div className="Widget-header mb-4 w-full border-b border-black text-left font-heading text-2xl leading-[1.3] text-black max-[700px]:text-base max-[700px]:leading-6 [&>span]:inline-block [&>span]:border-b [&>span]:border-accent [&>span]:-mb-px">
        <span>{data.header}</span>
      </div>
      <div className="Widget-container relative mx-auto flex w-full max-w-[820px] flex-wrap items-start justify-between max-[1100px]:mx-auto max-[1100px]:max-w-[565px] max-[1100px]:w-[calc(100vw-80px)] max-[600px]:max-w-[565px] max-[600px]:w-[calc(100vw-40px)]">
        {data.components?.edges?.map((edge) => {
          if (!edge?.node) {
            return null;
          }
          const Type = WidgetTypeMap[edge.node.__typename as keyof typeof WidgetTypeMap];
          if (!Type) {
            return null;
          }
          return <Type key={edge.node.id} location={location} component={edge.node} />;
        })}
      </div>
    </div>
  );
};
